export enum AccountType{
    DIRECTION='direction',
    OPERATION='operations',
    NATION='nation',
    SUPPORT='support',
    DISTRIBUTOR='distributeur',
}